<div class="input-group">
  @if (label) {
    <div class="input-group-prepend">
      <span class="input-group-text">{{ label | translate }}</span>
    </div>
  }
  <ng-content></ng-content>
</div>
